window.addEventListener('popstate', function () {
  loadPage(window.location.href, false)
});

window.lastState = window.location.href

window.loadPage = function (url, pushState = true) {
  if (typeof(counterScanHandler) !== 'undefined') {
    document.removeEventListener("keydown", counterScanHandler);
  }
  if (typeof(materialPreparationScanHandler) !== 'undefined') {
    document.removeEventListener("keydown", materialPreparationScanHandler);
  }

  $('.content').find('.container-fluid').html(setSpinner())
  if (pushState) { window.history.pushState('', '', url) }
  $.ajax({
    url: url,
    dataType: 'script',
    success: function(res, q, c){
      lastState = url
      $('.content').find('.container-fluid').html(res)
      feather.replace();
      caller()
    }, 
    error: function(jqXHR){
      if (jqXHR.status == 423 || jqXHR.status == 403) {
        const json = JSON.parse(jqXHR.responseText)
        
        if (json.message) {
          showToast("error", "", json.message)
        }

        if (json.redirect) {
          loadPage(json.redirect)
        } else {
          loadPage(lastState)
        }
      } else {
        alert ("Error: something went wrong")
      }
    }
  })
}

document.addEventListener("DOMContentLoaded", () => {
  $(document).on("click", "a", function(e){
    var href = $(this).attr("href")
    if (href == undefined || href == "" || href == "javascript:void(0);" || href.charAt(0) == "#"){
      return true;
    }
    
    var target = $(this).attr("target")
    if (target != undefined && target != ""){
      return true;
    }

    e.preventDefault();
    loadPage(href, true)
  })
})

